import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faPlay } from "@fortawesome/free-solid-svg-icons";
import { fmtCredits } from "../../utils/credits";

// Dégradé animé par famille de modèle — remplace la vignette vidéo réelle
// (façon Higgsfield) par une texture de mouvement propre à chaque provider.
const FAMILY_GRADIENT = {
  flux:     "from-emerald-500 via-teal-500 to-cyan-500",
  soul:     "from-fuchsia-600 via-purple-600 to-indigo-600",
  seedream: "from-orange-500 via-rose-500 to-fuchsia-600",
  gemini:   "from-blue-500 via-indigo-500 to-violet-600",
  seedance: "from-red-500 via-orange-500 to-amber-500",
  kling:    "from-cyan-500 via-blue-600 to-indigo-700",
  dop:      "from-lime-500 via-emerald-500 to-teal-600",
  ugc:      "from-pink-500 via-rose-500 to-orange-500",
};

const SPEED_BADGE = { rapide: "bg-white/20 text-white", moyen: "bg-white/20 text-white", lent: "bg-white/20 text-white" };

const ModelSceneCard = ({ model, selected, onSelect }) => {
  const locked = model.unlocked === false;
  const unavailable = model.available === false;
  const disabled = locked || unavailable;
  const gradient = FAMILY_GRADIENT[model.family] || "from-slate-600 via-slate-700 to-slate-800";

  return (
    <button
      onClick={() => !disabled && onSelect(model)}
      disabled={disabled}
      className={`group relative text-left rounded-2xl overflow-hidden h-40 flex flex-col justify-end transition ring-2 ${
        selected ? "ring-fuchsia-500 shadow-lg shadow-fuchsia-500/20" : "ring-transparent hover:ring-white/40"
      } ${disabled ? "opacity-50 cursor-not-allowed grayscale" : ""}`}
    >
      {/* Fond « scène » animé — dégradé qui dérive lentement + grain léger */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} bg-200 animate-aurora`} />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.25),transparent_60%)]" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

      {/* Icône lecture — évoque une vignette vidéo, apparaît au survol */}
      {!disabled && (
        <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-black/30 backdrop-blur flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
          <FontAwesomeIcon icon={faPlay} className="text-white text-[10px] translate-x-[1px]" />
        </span>
      )}
      {locked && (
        <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-black/40 backdrop-blur flex items-center justify-center">
          <FontAwesomeIcon icon={faLock} className="text-white text-[10px]" />
        </span>
      )}

      <span className="absolute top-3 left-3 text-[11px] font-bold bg-black/30 backdrop-blur text-white px-2 py-0.5 rounded-full">
        {fmtCredits(model.credits)} cr
      </span>

      <div className="relative z-10 p-3">
        <p className="font-bold text-white text-sm drop-shadow">{model.label}</p>
        <p className="text-[11px] text-white/80 line-clamp-2 mt-0.5">{model.description}</p>
        <div className="flex items-center gap-1.5 mt-2">
          <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${SPEED_BADGE[model.speed] || "bg-white/20 text-white"}`}>{model.speed}</span>
          <span className="text-[10px] text-white/60 font-medium">{model.provider}</span>
          {unavailable && <span className="text-[10px] font-bold bg-red-500/80 text-white px-2 py-0.5 rounded-full">non configuré</span>}
        </div>
      </div>
    </button>
  );
};

export default ModelSceneCard;
